import React from 'react'

const DynamicTable = (props) => {

    const {data} = props
    // Convert the data string into an object by splitting it by newline and colon.

    // const cleanedData = () => {
    //     console.log(data);
    //     const cleanedData = data
    //         .split(",") // Split based on commas instead of `\n`
    //         .map(item => item.replace(/[{}"]/g, '')) // Remove braces and quotes
    //         .reduce((acc, item) => {
    //             const [key, value] = item.split(": ");
    //             if (key && value) {
    //                 acc[key.trim()] = value.trim(); // Add key-value pair if both key and value exist
    //             }
    //             return acc;
    //         }, {});
    //     console.log(cleanedData);
    //     return cleanedData;
    // };

    const cleanedData = () => {
        console.log("Original Data:", data);
        let cleanedData;
    
        try {
            // Step 1: Try to parse `data` as JSON directly
            cleanedData = 
            (() => {
              try {
                  return JSON.parse(data);
              } catch (e) {
                  return data;
              }
          })()
        } catch (e) {
            // Step 2: If parsing fails, assume it's a JSON-like string without proper JSON formatting
            console.warn("Data is not valid JSON, applying custom parsing...");
    
            cleanedData = data
                .replace(/[{}"]/g, '') // Remove braces and quotes
                .split(",") // Split based on commas
                .reduce((acc, item) => {
                    const [key, value] = item.split(/:\s?/); // Split by `:` with optional space
                    if (key && value) {
                        acc[key.trim()] = value.trim(); // Trim whitespace from both key and value
                    }
                    return acc;
                }, {});
        }
    
        console.log("Cleaned Data:", cleanedData);
        return cleanedData;
    };
   



 
  // Function to capitalize the first letter of each key
   const formatKey = (key) => key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
   

   return (
    <table
      style={{
        border: "1px solid #ccc",
        borderCollapse: "collapse",
        width: "96%",
        marginTop: "12px",
        backgroundColor: "#ffffff",
        marginBottom:'20px'
      }}
    >
      <tbody>
          {Object.entries(props?.obj ? props?.obj : cleanedData()).map(([key, value], index, array) => {
          
            if (key === "ucId") return null; 

            return (
              <tr
                className="table-head"
                key={key}
                style={{
                  borderTopLeftRadius: index === 0 ? "10px" : "0",
                  borderTopRightRadius: index === 0 ? "10px" : "0",
                  borderBottomLeftRadius: index === array.length - 1 ? "10px" : "0",
                  borderBottomRightRadius: index === array.length - 1 ? "10px" : "0",
                }}
              >
                <td
                  className="call-logs-table"
                  style={{
                    borderTopLeftRadius: index === 0 ? "10px" : "0",
                    borderBottomLeftRadius: index === array.length - 1 ? "10px" : "0",
                  }}
                >
                  <strong>{formatKey(key)}</strong>
                </td>
                <td
                  className="call-logs-table"
                  style={{
                    fontWeight: "400",
                    borderTopRightRadius: index === 0 ? "10px" : "0",
                    borderBottomRightRadius: index === array.length - 1 ? "10px" : "0",
                  }}
                >
                  {value}
                </td>
              </tr>
            );
          })}
          </tbody>

    </table>
  );
  
}

export default DynamicTable